import React from 'react'
import { FlexDiv } from 'components/generic/HomePageComponents'
import {
  Anchor,
  CenteredContent,
  CenteringContainer,
  LargeLogoContainer,
  LargeNavContainer,
  NavigationItem,
  NavigationItems,
} from 'components/Header/Styled'
import ProfileDropDown from 'components/Header/LoggedIn/Large/ProfileDropDown'
import UpgradeCta from 'components/Header/LoggedIn/UpgradeCta'

const MyProfile = ({
  title,
  href,
  navigationItems,
  EligibleForUpgrade,
  isSubscribed,
  hasListing,
  showUpgradeCta,
}) => (
  <NavigationItems isRight>
    {showUpgradeCta && (
      <UpgradeCta
        EligibleForUpgrade={EligibleForUpgrade}
        isSubscribed={isSubscribed}
        hasListing={hasListing}
      />
    )}
    <NavigationItem>
      <CenteringContainer>
        <ProfileDropDown title={title} href={href} navigationItems={navigationItems} />
      </CenteringContainer>
    </NavigationItem>
  </NavigationItems>
)

const HeaderLinks = ({ navigationItems }) => {
  return (
    navigationItems &&
    navigationItems.length > 0 &&
    navigationItems.map((item, index) => (
      <NavigationItem key={`large_header_navlink${item.link}${index}`}>
        <Anchor href={item.link} title={item.title}>
          <CenteringContainer>
            <CenteredContent>{item.title}</CenteredContent>
          </CenteringContainer>
        </Anchor>
      </NavigationItem>
    ))
  )
}

export const LoggedInLargeHeader = ({
  altTag,
  logo,
  loggedInNavigationItems,
  title,
  profileLink,
  profileNavigationItems,
  profileEligibleForUpgrade,
  isSubscribed,
  hasListing,
  showUpgradeCta,
}) => (
  <LargeNavContainer>
    <FlexDiv maxWidth='1170px' width='100%' alignItems='center'>
      <LargeLogoContainer>
        <a href='/'>
          <img alt={altTag} src={logo} height={70} />
        </a>
      </LargeLogoContainer>
      <HeaderLinks navigationItems={loggedInNavigationItems} />
      <MyProfile
        title={title}
        href={profileLink}
        navigationItems={profileNavigationItems}
        EligibleForUpgrade={profileEligibleForUpgrade}
        isSubscribed={isSubscribed}
        hasListing={hasListing}
        showUpgradeCta={showUpgradeCta}
      />
    </FlexDiv>
  </LargeNavContainer>
)
